<template>
  <div class="extract-rewards">
    <div
      class="extract-rewards-btn"
      :class="{ disabled: extracting }"
      @click="handleExtract"
    >
      {{ $t('monopoly.extractRewards') }}
    </div>
    <div class="extract-rewards-desc">
      {{ $t('monopoly.extractRewardsDesc') }}
    </div>
    <ExtractSuccessDialog
      v-model="successVisible"
      :rewards="extractRewards"
    />
  </div>
</template>

<script setup>
import { computed, inject, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { toastService } from '@/utils/toastService'
import MonopolyApi from '@/views/act/monopoly/api'
import ExtractSuccessDialog from '../ExtractSuccessDialog/index.vue'
import { trackClaimRewards, trackLapReward, toTrackRewards } from '@/views/act/monopoly/utils/track'

const store = useStore()
const { t } = useI18n()
const activityInfo = inject('monopolyActivityInfo')
const refreshActivityInfo = inject('refreshMonopolyActivityInfo', () => Promise.resolve())
const refreshLapRewardList = inject('refreshMonopolyLapRewardList', () => Promise.resolve())
const openMonopolyLogin = inject('openMonopolyLogin', () => {})

const extracting = ref(false)
const successVisible = ref(false)
const extractRewards = ref([])

const isLoggedIn = computed(() => !!store.state.actUserInfo?.token)
const pendingCount = computed(() => Number(activityInfo?.pendingRewardCount || 0))
const hasLapReward = computed(() => !!activityInfo?.lapRewardRedDot)
const hasClaimable = computed(() => pendingCount.value > 0 || hasLapReward.value)

const handleExtract = async () => {
  if (extracting.value) return
  if (!isLoggedIn.value) {
    openMonopolyLogin()
    return
  }
  if (!hasClaimable.value) {
    toastService.show(t('monopoly.noPendingRewards'))
    return
  }

  extracting.value = true
  try {
    // 提取前记录可领圈数档，便于埋点（服务端会一并领取）
    let claimableLaps = []
    if (hasLapReward.value) {
      try {
        const lapRes = await MonopolyApi.getLapRewardList()
        claimableLaps = (lapRes?.list || []).filter((row) => row.status === 1)
      } catch (e) {
        console.error(e)
      }
    }

    const res = await MonopolyApi.extractRewards()
    extractRewards.value = res?.props || []
    if (activityInfo) {
      activityInfo.pendingRewardCount = 0
      activityInfo.extractRedDot = false
      activityInfo.lapRewardRedDot = false
    }
    successVisible.value = true
    trackClaimRewards({ rewardCount: extractRewards.value.length })
    claimableLaps.forEach((row) => {
      trackLapReward({
        rewardDetail: toTrackRewards(row.props),
        milestoneLap: row.targetLaps,
      })
    })
    await Promise.all([refreshActivityInfo(), refreshLapRewardList()])
  } catch (e) {
    console.error(e)
    await Promise.all([refreshActivityInfo(), refreshLapRewardList()])
  } finally {
    extracting.value = false
  }
}
</script>

<style lang="less" scoped>
.extract-rewards {
  margin-top: 30px;
  .extract-rewards-btn {
    margin: 0 auto;
    width: 396px;
    height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('~@/views/act/monopoly/assets/img/extract-rewards-btn.png') no-repeat center center / 100% 100%;
    color: #fff;
    font-size: 50px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;

    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }
  }
  .extract-rewards-desc {
    margin-top: 20px;
    font-size: 22px;
    color: #12215C;
    text-align: center;
  }
}
</style>
